import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { noop, isNil, isEqual } from 'lodash'
import { compose, shouldUpdate } from 'recompose'

import { formatValue } from 'utils/formatters/value'
import { FormBlock } from 'components/formBlock/FormBlock'
import { Textarea } from 'components/textarea/Textarea'

import styles from 'components/form/textarea/FormTextarea.module.scss'

const FormTextareaView = ({
  field,
  title,
  placeholder,
  isReadonly,
  isDisabled,
  isRequired,
  onChange,
  handleFieldChange,
  className,
  fieldHeight = 81,
  ...props
}) => {
  const fieldChangeHandler = handleFieldChange ? handleFieldChange(field.name) : noop
  const handleChange = onChange ? onChange : fieldChangeHandler
  const isRequiredField = isNil(isRequired) ? field.isRequired : isRequired

  return (
    <FormBlock
      title={title}
      readonlyView={formatValue(field.value)}
      isReadonly={!!isReadonly}
      isRequired={!!isRequiredField}
      className={classNames(className)}>
      <Textarea
        className={styles.textarea}
        onChange={handleChange}
        value={field.value || ''}
        placeholder={placeholder}
        error={field.error}
        isDisabled={isDisabled}
        height={fieldHeight}
        {...props}
      />
    </FormBlock>
  )
}

FormTextareaView.propTypes = {
  field: PropTypes.object.isRequired,
  title: PropTypes.node,
  placeholder: PropTypes.node,
  isDisabled: PropTypes.bool,
  isReadonly: PropTypes.bool,
  isRequired: PropTypes.bool,
  onChange: PropTypes.func,
  className: PropTypes.string,
  handleFieldChange: PropTypes.func,
  fieldHeight: PropTypes.number,
  error: PropTypes.string,
}

export const FormTextarea = compose(shouldUpdate((props, nextProps) => !isEqual(props, nextProps)))(FormTextareaView)

FormTextarea.propTypes = {
  field: PropTypes.object.isRequired,
  title: PropTypes.node,
  placeholder: PropTypes.node,
  isDisabled: PropTypes.bool,
  isReadonly: PropTypes.bool,
  isRequired: PropTypes.bool,
  onChange: PropTypes.func,
  className: PropTypes.string,
  handleFieldChange: PropTypes.func,
  fieldHeight: PropTypes.number,
}
